var React = require('react');

function GenericCreditCard (props) {
    return React.createElement("svg",props,[React.createElement("desc",{"key":0},"Generic Credit Card Icon"),React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"Generic-Credit-Card"},[React.createElement("rect",{"id":"Background","fill":"#48A1DD","x":"0","y":"0","width":"360","height":"247","rx":"15","key":0}),React.createElement("rect",{"id":"Rectangle-19","fill":"#465186","x":"0","y":"55","width":"360","height":"45","key":1}),React.createElement("rect",{"id":"Rectangle-19-Copy","fill":"#FFFFFF","x":"43","y":"188","width":"129","height":"21","rx":"10.5","key":2}),React.createElement("rect",{"id":"Rectangle-20","fill":"#465186","x":"253","y":"144","width":"63","height":"65","rx":"15","key":3})]))]);
}

GenericCreditCard.defaultProps = {"viewBox":"0 0 360 247","version":"1.1"};

module.exports = GenericCreditCard;

GenericCreditCard.default = GenericCreditCard;
